import { render } from "./DuplicateMenuset.vue?vue&type=template&id=2597bf74&scoped=true"
import script from "./DuplicateMenuset.vue?vue&type=script&lang=js"
export * from "./DuplicateMenuset.vue?vue&type=script&lang=js"

import "./DuplicateMenuset.vue?vue&type=style&index=0&id=2597bf74&scoped=true&lang=css"

import exportComponent from "/var/www/html/minty.crm.frontend.merchant/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2597bf74"]])

export default __exports__